import ReactDOM from 'react-dom';
import React from 'react';
import PropTypes from 'prop-types';

import IconAdd from '../content/list/svg/IconAdd';
import IconCart from '../content/list/svg/IconCart';
import IconAddedCart from '../content/list/svg/IconAddedCart';
import useTrackAccess from '../content/list/hooks/useTrackAccess';

function PortalActions({ rootID, item }) {
  const root = document.getElementById(rootID);
  const { addToCart, isInCart, addToPlaylist } = useTrackAccess(item, rootID, 0);
  if (root && item) {
    let el = document.createElement('div');
    if (root.lastChild) {
      root.removeChild(root.lastChild);
    }
    root.appendChild(el);

    return ReactDOM.createPortal((
      <div id={`player-more-ref-${item.id}`} className={'flexRow player-deck-actions'} style={{ gap: 5, textAlign: `-webkit-center`, cursor: 'pointer', zIndex: 50 }}>
        <div className={'player-deck-add-cart'} onClick={addToCart}>
          { isInCart ? <IconAddedCart color={'#B3B3B3'} size={20} /> : <IconCart color={'#B3B3B3'} size={20} /> }
        </div>
        <div className={'player-deck-add'} onClick={addToPlaylist}>
          <IconAdd color={'#B3B3B3'} size={20} />
        </div>
      </div>
    ), el);
  } else {
    return null
  }
}

PortalActions.propTypes = {
  rootID: PropTypes.string.isRequired,
  item: PropTypes.object
}

export default PortalActions;
